import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})
export class ConsultaEncuestaService {

  constructor(
    private http: HttpClient
  ) { }

  getInstitutos() {
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.ods.getInstituteArray);
  }

  getPaisesBroker(broker:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getPaisesBroker + broker);
  }

  getDatosEncuestas(anio:number, broker:number, brokerCountry:string,rankingYear:number,idioma:any){
    return this.http.get(`${DATOS_API.url}${DATOS_API.endpoints.getMasterFileService_v3}${anio}/${broker}/${brokerCountry}/${rankingYear}/${idioma}`);
  }
}
